import React from 'react';
import { Truck, Package, DollarSign, Calendar } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { formatCurrency } from '../../lib/utils';
import { useCanSeeAmounts } from '../../context/PermissionsContext';

export function DispatchStats({ 
  totalDispatches, 
  totalQuantity, 
  totalValueFiltered, 
  uniqueLotes, 
  isFiltered 
}) {
  const canSeeAmounts = useCanSeeAmounts('dispatches');
  return (
    <div className={`grid grid-cols-1 gap-4 ${canSeeAmounts ? 'sm:grid-cols-4' : 'sm:grid-cols-3'}`}>
      <Card className="border-slate-200">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#931A25]/10 flex items-center justify-center">
              <Truck className="h-5 w-5 text-[#931A25]" />
            </div>
            <div>
              <p className="text-xs text-slate-500">Total Despachos</p>
              <p className="font-bold text-lg">{totalDispatches}</p>
              {isFiltered && <p className="text-xs text-blue-600">Filtrado</p>}
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="border-slate-200">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
              <Package className="h-5 w-5 text-green-600" />
            </div>
            <div>
              <p className="text-xs text-slate-500">Total Despachado</p>
              <p className="font-bold text-lg">{totalQuantity.toFixed(2)} qq</p>
              {isFiltered && <p className="text-xs text-blue-600">Filtrado</p>}
            </div>
          </div>
        </CardContent>
      </Card>
      {canSeeAmounts && (
      <Card className="border-slate-200">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center">
              <DollarSign className="h-5 w-5 text-yellow-600" />
            </div>
            <div>
              <p className="text-xs text-slate-500">Valor Total</p>
              <p className="font-bold text-lg">{formatCurrency(totalValueFiltered.usd, 'USD')}</p>
              <p className="text-xs text-blue-600">({formatCurrency(totalValueFiltered.dop)})</p>
            </div>
          </div>
        </CardContent>
      </Card>
      )}
      <Card className="border-slate-200">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
              <Calendar className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <p className="text-xs text-slate-500">Lotes Activos</p>
              <p className="font-bold text-lg">{uniqueLotes}</p>
              {isFiltered && <p className="text-xs text-blue-600">Filtrado</p>}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
